import { AccessControlActionTypes } from '@bridebook/web/lib/access-control/action-types';
import { ICollaborator } from '@bridebook/web/lib/access-control/types';

export const fetchCollaboratorsEmailsSuccess = (collaborators: Array<ICollaborator>) => ({
  type: AccessControlActionTypes.FETCH_COLLABORATORS_EMAILS_SUCCESS,
  payload: collaborators,
});
